"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPersonalProductLists = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _utils = require("../utils");
/* istanbul ignore file -- api */

const getPersonalProductLists = async ({
  client,
  customerId
}) => {
  const {
    data: {
      maximumAllowedRecords,
      productLists
    }
  } = await (0, _globalApiClientReact.getCustomerProductListTypeProductLists)(client, customerId, 'Personal');
  const lists = productLists.reduce((acc, list) => {
    const {
      productListId
    } = list;
    if (productListId !== undefined) {
      acc.push((0, _utils.mapGlobalApiProductListToList)({
        list: {
          ...list,
          productListId
        },
        type: 'Personal'
      }));
    }
    return acc;
  }, []);
  return {
    lists,
    maximumAllowedPersonalLists: maximumAllowedRecords
  };
};
exports.getPersonalProductLists = getPersonalProductLists;
//# sourceMappingURL=getPersonalProductLists.js.map